

























































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { Logger } from '@/Shared/Logger';
import { IDefaultGridColumns } from '@/Shared/IDefaultGridColumns';
import { BRow } from 'bootstrap-vue';
import { TranslateResult } from 'vue-i18n';
import { ChalkingLocationRule } from './ChalkingLocationRule';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';

export default mixins(LocationBasedMixin).extend({
    data() {
        return {
            editItem: {isAddItem: false} as any as ChalkingLocationRule,
            addItem: {isAddItem: true} as any as ChalkingLocationRule,
            items: [] as ChalkingLocationRule[],
            loadingItems: {} as { [key: number]: boolean },
            validationErrors: {} as { [key: string]: string[] }
        };
    },
    methods: {
        editing(item: ChalkingLocationRule) {
            if ((item as any).isAddItem) {
                return true;
            }
            else if (this.editItem && this.editItem.recID && !(this.editItem as any).isAddItem) {
                return this.editItem.recID === item.recID;
            }
            else {
                return false;
            }
        },
        edit(item: ChalkingLocationRule) {
            this.editItem = { ...item };
        },
        add() {
            this.editItem = { ...this.addItem };
        },
        async save(item: ChalkingLocationRule) {
            Vue.set(this.loadingItems, item.recID, true);
            try {
                await VatsAPI.post<ChalkingLocationRule>(`${this.location}/ChalkingLocationRules/UpsertChalkingLocationRule`, item);
                await this.refreshItems();
                this.editItem = {} as ChalkingLocationRule;
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                Vue.set(this.loadingItems, item.recID, false);
            }
        },
        async deleteItem(item: ChalkingLocationRule) {
            const deleteConfirmMessage =
                this.$i18n.t( 'admin.chalkingLocationRules.deleteConfirmMessage', {
                    // lot: item.lotID,
                    // block: item.blockNumber
                }).toString();
            const deleteConfirmTitle = this.$i18n.t('admin.chalkingLocationRules.deleteConfirmTitle').toString();
            const deleteButton = this.$i18n.t('common.delete').toString();
            const cancelButton = this.$i18n.t('common.cancel').toString();

            const confirmDelete = await this.$bvModal.msgBoxConfirm(
                deleteConfirmMessage,
                {
                    title: deleteConfirmTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'info',
                    okTitle: deleteButton,
                    cancelTitle: cancelButton,
                    centered: true
                }
            );

            if (confirmDelete) {
                try {
                    Vue.set(this.loadingItems, item.recID, true);
                    await VatsAPI.delete(`${this.location}/ChalkingLocationRules`, {data: [item]});
                    await this.refreshItems();
                    Vue.set(this.loadingItems, item.recID, false);
                }
                catch (e) {
                    this.$bvToast.toast('admin.chalkingLocationRules.deleteRuleError', {
                        title: this.$i18n.t('common.error').toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
            }
        },
        cancelEdit() {
            this.editItem = { isAddItem: false } as any as ChalkingLocationRule;
            this.addItem = { isAddItem: true } as any as ChalkingLocationRule;
        },
        async refreshItems() {
            try {
                const axiosResponse = await VatsAPI.get<ChalkingLocationRule[]>(`${this.location}/ChalkingLocationRules/GetChalkingLocationRules`);
                this.items = axiosResponse.data;
            }
            catch (e) {
                this.$bvToast.toast('refreshRulesError', {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async locationChanged() {
            await this.refreshItems();
        }
    },
    async mounted() {
        this.refreshItems();
    }
});
